import fa from "vee-validate/dist/locale/fa.json";

export default {
  Language: [
    {
      key: 'Fa', text: 'فارسی', value: 0, badge: 'info',
    },
    {
      key: 'En', text: 'انگلیسی', value: 1, badge: 'success',
    },
    {
      key: 'Ar', text: 'عربی', value: 2, badge: 'warning',
    },
  ],
  Status: [
    {
      key: 'Pending', text: 'در حال بررسی', value: 0, badge: 'secondary',
    },
    {
      key: 'Accepted', text: 'تایید شده', value: 1, badge: 'success',
    },
    {
      key: 'Failed', text: 'رد شده', value: 2, badge: 'warning',
    },
  ],
  StopDiet: [
    {
      text: 'آزاد', value: false,
    },
    {
      text: 'خطرناک', value: true,
    },
  ],
  Level: [
    {
      key: 'Beginner', text: 'مقدماتی', value: 0, badge: 'secondary',
    },
    {
      key: 'Intermediate', text: 'پیشرفته', value: 1, badge: 'info',
    },
    {
      key: 'Advanced', text: 'حرفه ای', value: 2, badge: 'warning',
    },
    {
      key: 'Professional', text: 'فوق حرفه ای', value: 3, badge: 'danger',
    },
  ],
  IsPaid: [
    {
      text: 'پرداخت شده', value: true,
    },
    {
      text: 'پرداخت نشده', value: false,
    },
  ],
  IsActive: [
    {
      text: 'فعال', value: true, badge: 'success',
    },
    {
      text: 'غیرفعال', value: false, badge: 'secondary',
    },
  ],
  IsDeactive: [
    {
      text: 'غیرفعال', value: true,
    },
    {
      text: 'فعال', value: false,
    },
  ],
  UserStatus: [
    {
      text: 'تکمیل پروفایل', value: 0, badge: 'info',
    },
    {
      text: 'اطلاعات سایز', value: 1, badge: 'info',
    },
    {
      text: 'پرسش و پاسخ', value: 2, badge: 'info',
    },
    {
      text: 'بررسی پرسش و پاسخ', value: 3, badge: 'primary',
    },
    {
      text: 'سوال اختصاصی', value: 4, badge: 'info',
    },
    {
      text: 'آماده سازی رژیم', value: 5, badge: 'primary',
    },
    {
      text: 'استفاده از رژیم', value: 6, badge: 'success',
    },
    {
      text: 'وزن کشی 14 روزه', value: 7, badge: 'success',
    },
    {
      text: 'هشدار تمدید رژیم', value: 8, badge: 'warning',
    },
    {
      text: 'نیاز به تمدید رژیم', value: 9, badge: 'warning',
    },
    {
      text: 'غیرفعال', value: 10, badge: 'secondary',
    },
    {
      text: 'وزن کشی 30 روزه', value: 11, badge: 'primary',
    },
    {
      text: 'بررسی سایز و وزن توسط کارشناس', value: 12, badge: 'info',
    },
  ],
  Company: [
    {
      text: 'زیره', value: 0, badge: 'success',
    },
    {
      text: 'کارسو', value: 1, badge: 'secondary',
    },
  ],
  UserAffiliateStatus: [
    {
      text: 'جدید', value: 0, badge: 'info',
    },
    {
      text: 'در حال بررسی', value: 1, badge: 'secondary',
    },
    {
      text: 'تایید شده', value: 2, badge: 'success',
    },
    {
      text: 'رد شده', value: 3, badge: 'warning',
    },
  ],
  UserAffiliateSettlementStatus: [
    {
      text: 'در حال بررسی', value: 0, badge: 'secondary',
    },
    {
      text: 'آماده جهت پرداخت', value: 1, badge: 'success',
    },
    {
      text: 'پرداخت شده', value: 2, badge: 'success',
    },
    {
      text: 'رد شده', value: 3, badge: 'warning',
    },
  ],
  UserAffiliatePaymentStatus: [
    { text: 'پرداخت شده', value: 0 },
    { text: 'پرداخت نشده', value: 1 },
  ],
  Target: [
    {
      key: 'Zireh', text: 'زیره', value: 0
    },
    {
      key: 'ZirehPlus', text: 'زیره پلاس', value: 1
    },
  ],
  ContentType: [
    {
      key: 'Onboarding', text: 'معرفی زیره', value: 0,
    },
    {
      key: 'Disclaimer', text: 'سلب مسئولیت', value: 1,
    },
    {
      key: 'LandingSlider', text: 'اسلایدر لندینگ', value: 2,
    },
    {
      key: 'ZirehAttributes', text: 'ویژگی های زیره', value: 3,
    },
    {
      key: 'ZirehHomePage', text: 'ویژگی های وب سایت', value: 4,
    },

  ],
  Entity: [
    {
      key: 'Food', text: 'غذا', value: 0,
    },
    {
      key: 'Activity', text: 'فعالیت', value: 1,
    },
    {
      key: 'Blog', text: 'مجله', value: 2,
    },
    {
      key: 'FoodComment', text: 'نظرات', value: 3,
    },
  ],
  ReportStatus: [
    {
      key: 'New', text: 'جدید', value: 0, badge: 'success',
    },
    {
      key: 'InProgress', text: 'در حال بررسی', value: 1, badge: 'warning',
    },
    {
      key: 'Closed', text: 'بسته شده', value: 2, badge: 'secondary',
    },
  ],
  AmountType: [
    {
      key: 'Percent', text: 'درصد', value: 0,
    },
    {
      key: 'Price', text: 'مبلغ', value: 1,
    },
  ],

  Advertiser: [
    {
      key: 'Zireh', text: 'زیره', value: 0,
    },
    {
      key: 'Tapsell', text: 'تپسل', value: 1,
    },
    {
      key: 'AdMobe', text: 'گوگل', value: 2,
    },
  ],
  Screen: [
    {
      key: 'Dashboard', text: 'داشبورد', value: 18,
    },
    {
      key: 'FoodBank', text: 'بانک خوراکی ها', value: 1,
    },
    {
      key: 'ActivityBank', text: 'بانک فعالیت ها', value: 2,
    },
    {
      key: 'Blog', text: 'مجله', value: 3,
    },
    {
      key: 'PlanFood', text: 'وعده ها', value: 4,
    },
    {
      key: 'Water', text: 'آب شمار', value: 5,
    },
    {
      key: 'Weight', text: 'وزن کشی', value: 6,
    },
    {
      key: 'Contact', text: 'تماس با ما', value: 7,
    },
    {
      key: 'About', text: 'درباره ما', value: 8,
    },
    {
      key: 'Ticket', text: 'تیکت ها', value: 9,
    },
    {
      key: 'Notification', text: 'تنظیمات اعلان', value: 10,
    },
    {
      key: 'FoodDetails', text: 'جزپیات خوارکی', value: 11,
    },
    {
      key: 'ActivityDetails', text: 'جزپیات فعالیت', value: 12,
    },
    {
      key: 'BlogDetails', text: 'جزپیات مقاله', value: 13,
    },
    {
      key: 'PlanActivity', text: 'فعالیت های روزانه', value: 14,
    },
    {
      key: 'Support', text: 'پشتیبانی', value: 15,
    },
    {
      key: 'Exchange', text: 'جایگزینی', value: 16,
    },
    {
      key: 'AppTutorial', text: 'آموزش اپ', value: 17,
    },
    {
      key: 'Diet', text: 'برنامه غذایی', value: 0,
    },
    {
      key: 'FoodRecipes', text: 'دستورپخت', value: 19,
    },
    {
      key: 'FoodSuggestion', text: 'غذای پیشنهادی', value: 20,
    },
    {
      key: 'SportDetails', text: 'دوره ورزشی', value: 21,
    },
    {
      key: 'SportGroup', text: 'گروه ورزشی', value: 22,
    },
    {
      key: 'SportSubGroup', text: 'برنامه ورزشی', value: 23,
    },
    {
      key: 'Videos', text: 'ویدئو', value: 24,
    },
    {
      key: 'VideoDetails', text: 'جزئیات ویدئو', value: 25,
    },
    {
      key: 'Services', text: 'خدمات', value: 26,
    },
    {
      key: 'ChatGroup', text: 'گروه چت', value: 28,
    },
    {
      key: 'DietSelectFood', text: 'انتخاب غذا در رژیم', value: 29,
    },
    {
      key: '.....', text: '....', value: 27,
    },
  ],
  Sorting: [
    {
      key: 'Sort', text: 'ترتیب بنرها', value: 0,
    },
    {
      key: 'Random', text: 'رندوم', value: 1,
    },
    {
      key: 'AscendingClick', text: 'کمترین کلیک', value: 2,
    },
    {
      key: 'DescendingClick', text: 'بیشترین کلیک', value: 3,
    },
  ],
  BannerType: [
    {
      key: 'Single', text: 'تکی', value: 0,
    },
    {
      key: 'List', text: 'لیست', value: 1,
    },
    {
      key: 'Slide', text: 'اسلاید', value: 2,
    },
    {
      key: 'Simple', text: 'ساده', value: 3,
    },
  ],
  ActivityAmountType: [
    {
      key: 'Second', text: 'ثانیه', value: 0,
    },
    {
      key: 'Number', text: 'عدد', value: 1,
    },
  ],
  ActivitySide: [
    {
      key: 'Left', text: 'چپ', value: 0,
    },
    {
      key: 'Right', text: 'راست', value: 1,
    },
  ],
  SicknessCategory: [
    { key: 'Public', text: 'بیماری های عمومی', value: 0 },
    { key: 'JointAndBone', text: 'بیماری های مفصلی و استخوانی', value: 1 },
    { key: 'Digestive', text: 'بیماری های گوارشی', value: 2 },
    { key: 'Nervous', text: 'بیماری های عصبی', value: 3 },
  ],
  FaqCategory: [
    { key: 'Food', text: 'لیست خوراکی ها', value: 0 },
    { key: 'Diet', text: 'دریافت رژیم', value: 1 },
    { key: 'Order', text: 'پرداخت', value: 2 },
    { key: 'Calorie', text: 'کالری شماری', value: 3 },
  ],
  StepType: [
    { key: 'OneFourth', text: 'یک چهارم', value: 0 },
    { key: 'OneThird', text: 'یک سوم', value: 1 },
    { key: 'OneSecond', text: 'یک دوم', value: 2 },
    { key: 'TwoThird', text: 'دو سوم', value: 3 },
    { key: 'ThreeFourth', text: 'سه چهارم', value: 4 },
    { key: 'One', text: 'یک', value: 5 },
  ],
  StepTypeEn: [
    { key: 'OneFourth', text: 'One Fourth', value: 0 },
    { key: 'OneThird', text: 'One Third', value: 1 },
    { key: 'OneSecond', text: 'One Second', value: 2 },
    { key: 'TwoThird', text: 'Two Third', value: 3 },
    { key: 'ThreeFourth', text: 'Three Fourth', value: 4 },
    { key: 'One', text: 'One', value: 5 },
  ],
  ActivationType: [
    {
      key: 'Deactive', text: 'غیرفعال', value: 0, badge: 'danger',
    },
    {
      key: 'Active', text: 'فعال', value: 1, badge: 'success',
    },
    {
      key: 'ComingSoon', text: 'به زودی', value: 2, badge: 'secondary',
    },
  ],
  NatureType: [
    {
      key: 'Cool', text: 'سرد', value: 0,
    },
    {
      key: 'Warm', text: 'گرم', value: 1,
    },
    {
      key: 'CoolAndDry', text: 'سرد و خشک', value: 2,
    },
    {
      key: 'CoolAndWet', text: 'سرد و تر', value: 3,
    },
    {
      key: 'WarmAndDry', text: 'گرم و خشک', value: 4,
    },
    {
      key: 'WarmAndWet', text: 'گرم و تر', value: 5,
    },
    {
      key: 'Temperate', text: 'معتدل', value: 6,
    },
  ],
  DietMethod: [
    { key: 'Fat', text: 'افزایش وزن', value: 0 },
    { key: 'Slim', text: 'کاهش وزن', value: 1 },
    { key: 'Fixation', text: 'تثبیت وزن', value: 2 },
  ],
  DietType: [
    { key: 'Vegetable', text: 'رژیم گیاهی', value: 0 },
    { key: 'CalorieDiet', text: 'رژیم کالری شماری', value: 1 },
    { key: 'FastingWithExpert', text: 'رژیم فستینگ با کارشناس', value: 2 },
    { key: 'Public', text: 'عمومی', value: 3 },
    { key: 'WithExpert', text: 'رژیم با کارشناس', value: 4 },
    { key: 'FastingCalorieDiet16852NoBreakfast', text: 'رژیم فستینگ ترکیب 16:8 و 5:2 بدون صبحانه کالری شماری', value: 5 },
    { key: 'FastingCalorieDiet16852NoDinner', text: 'رژیم فستینگ ترکیب 16:8 و 5:2 بدون شام کالری شماری', value: 6 },
    { key: 'FastingCalorieDiet168NoBreakfast', text: 'رژیم فستینگ 16:8 بدون صبحانه کالری شماری', value: 7 },
    { key: 'FastingCalorieDiet168NoDinner', text: 'رژیم فستینگ 16:8 بدون شام کالری شماری', value: 8 },
    { key: 'FastingCalorieDiet52', text: 'رژیم فستینگ 5:2 کالری شماری', value: 9 },
    { key: 'FastingCalorieDiet61', text: 'رژیم فستینگ 6:1 کالری شماری', value: 10 }
  ],
  VersionType: [
    {
      key: 'Version', text: 'برنامه', value: 0,
    },
    {
      key: 'Food', text: 'غذا', value: 1,
    },
    {
      key: 'Activity', text: 'فعالیت', value: 2,
    },
  ],
  Platform: [
    {
      key: 'Web', text: 'وب', value: 0,
    },
    {
      key: 'Android', text: 'اندروید', value: 1,
    },
    {
      key: 'iOS', text: 'آیفون', value: 2,
    },
  ],
  UserPermissionIcon: [
    { icon: 'UserIcon', color: 'secondary', key: 'User' },
    { icon: 'ApertureIcon', color: 'info', key: 'Activity' },
    { icon: 'TargetIcon', color: 'primary', key: 'Food' },
    { icon: 'SettingsIcon', color: 'secondary', key: 'Public' },
    { icon: 'PackageIcon', color: 'danger', key: 'Diet' },
    { icon: 'MessageSquareIcon', color: 'warning', key: 'Ticket' },
    { icon: 'DollarSignIcon', color: 'success', key: 'Sale' },
    { icon: 'BookOpenIcon', color: 'primary', key: 'Blog' },
  ],
  TicketStatus: [
    {
      key: 'New', value: 0, text: 'جدید', badge: 'success',
    },
    {
      key: 'UserReply', value: 1, text: 'پاسخ کاربر', badge: 'info',
    },
    {
      key: 'InProgress', value: 2, text: 'در حال بررسی', badge: 'warning',
    },
    {
      key: 'Closed', value: 3, text: 'پاسخ ادمین', badge: 'danger',
    },
    {
      key: 'AdminReply', value: 4, text: 'بسته', badge: 'primary',
    },
  ],
  Lactation: [
    { key: 'None', text: 'هیچ کدام', value: 0, badge: '' },
    { key: 'FirstSixMonths', text: 'شش ماهه اول', value: 1, badge: 'danger' },
    { key: 'SecondSixMonths', text: 'شش ماهه دوم', value: 2, badge: 'danger' },
    { key: 'ThirdSixMonths', text: 'شش ماهه سوم', value: 3, badge: '' },
    { key: 'FourthSixMonths', text: 'شش ماهه چهارم', value: 4, badge: '' },
    { key: 'null', text: 'ندارد', value: null, badge: '' },
  ],
  ActivityLevel: [
    { key: 'VeryLight', text: 'خیلی سبک ', value: 0 },
    { key: 'Light', text: 'سبک', value: 1 },
    { key: 'Medium', text: 'متوسط', value: 2 },
    { key: 'Heavy', text: 'سنگین', value: 3 },
    { key: 'VeryHeavy', text: 'خیلی سنگین', value: 4 },
  ],
  Gender: [
    { key: 'Man', text: 'مرد', value: 0 },
    { key: 'Woman', text: 'زن', value: 1 },
  ],
  requiredness: [
    { key: '', text: 'اجباری', value: true },
    { key: '', text: 'اختیاری', value: false },
  ],
  CouponUser: [
    { key: '', text: 'همه', value: false },
    { key: '', text: 'محدود', value: true },
  ],
  DietDifficulty: [
    { key: 'TwoKilosInMonth ', text: 'دو کیلو در ماه', value: 1 },
    { key: 'FourKilosInMonth ', text: 'چهار کیلو در ماه', value: 2 },
    { key: 'null', text: 'ندارد', value: null },
  ],
  bank: [
    { key: 'ZarinPalNoRasmi', text: 'زرین پال غیر رسمی', value: 0 },
    { key: 'Bazar', text: 'کافه بازار', value: 1 },
    { key: 'MyKet', text: 'مایکت', value: 2 },
    { key: 'Trial', text: 'آزمایشی', value: 3 },
    { key: 'ByAdmin', text: 'توسط ادمین', value: 4 },
    { key: 'Cart', text: 'کارت به کارت', value: 5 },
    { key: 'Zireh', text: 'زیره', value: 6 },
    { key: 'GooglePlay', text: 'گوگل پلی', value: 7 },
    { key: 'GooglePlayAutoActive', text: 'تمدید اتوماتیک گوگل پلی', value: 8 },
    { key: 'Saman', text: 'سامان', value: 9 },
    { key: 'ZarinPalRasmi', text: 'زرین پال رسمی', value: 10 },
  ],
  products: [
    {
      key: 'oneMonth', text: 'یک ماهه', value: [14, 1], abr: '1',
    },
    {
      key: 'threeMonth', text: 'سه ماهه', value: [15, 2], abr: '2',
    },
    {
      key: 'sixMonth', text: 'شیش ماهه', value: [16, 3], abr: '3',
    },
    {
      key: 'free', text: 'رایگان', value: [10], abr: '4',
    },
  ],
  durations: [
    { text: '1 روز اخیر', value: 1 },
    { text: '3 روز اخیر', value: 3 },
    { text: '7 روز اخیر', value: 7 },
    { text: '30 روز اخیر', value: 30 },
    { text: '60 روز اخیر', value: 60 },
    { text: '180 روز اخیر', value: 180 },
  ],
  ProductFlavor: [
    { value: 0, text: 'ناشناس', badge: 'secondary' },
    { value: 1, text: 'استیج', badge: 'warning' },
    { value: 2, text: 'مستقیم', badge: 'warning' },
    { value: 3, text: 'گوگل پلی', badge: 'success' },
    { value: 4, text: 'کافه بازار', badge: 'success' },
    { value: 5, text: 'مایکت', badge: 'success' },
    { value: 6, text: 'آی اپس', badge: 'info' },
    { value: 7, text: 'سیب اپ', badge: 'info' },
    { value: 8, text: 'اپ استور', badge: 'info' },
    { value: 9, text: 'وب', badge: 'primary' },
    { value: 10, text: 'زیروفیت', badge: 'danger' },
    { value: 11, text: 'پنل', badge: 'success' },
  ],
  NotificationScale: [
    { value: 0, text: 'تکی' },
    { value: 1, text: 'گروهی' },
  ],
  NotificationsGroups: [
    { value: 0, text: 'کاربران منقضی شده' },
    { value: 1, text: 'کاربران طلایی' },
  ],
  sendVia: [
    { value: 0, text: 'اعلان' },
    { value: 1, text: 'پیامک' }
  ],

  Repeat: [
    { value: true, text: 'فعال' },
    { value: false, text: 'غیرفعال' }
  ],
  notificationStatus: [
    { value: 'draft', text: 'پیش نویس', key: 'draft' },
    { value: 'waitToSent', text: 'در انتظار ارسال', ket: 'waitToSent' },
    { value: 'done', text: 'ارسال شده', key: 'done' },
  ],
  segmentType: [
    { value: 0, text: 'سگمنت پایه', component: 'selectSegmentBasic' },
    { value: 1, text: 'سگمنت سفارشی', component: 'selectSegmentCustom' },
    { value: 2, text: 'اعلان', component: 'selectDeclaration' },
  ],
  segmentOperator: [
    { value: 1, text: 'مساوی', key: 'equal' },
    { value: 2, text: 'بزرگتر از', key: 'greaterThan' },
    { value: 3, text: 'کوچکتر از', key: 'lessThan' },
  ],
  BlogContentType: [
    { value: 0, text: 'مقاله با عکس' },
    { value: 1, text: 'مقاله با ویدیو' },
  ],

  archive: [
    { value: true, text: 'غیرفعال' },
    { value: false, text: 'فعال' },
  ],
  errorStatus: [
    { value: false, text: 'باز' },
    { value: true, text: 'بسته' },
  ],
  questionType: [
    { value: 0, key: 'Radio', text: 'تک انتخابی' },
    { value: 1, key: 'Check', text: 'چند انتخابی' },
    { value: 2, key: 'Text', text: 'تشریحی' },
    { value: 3, key: 'Upload', text: 'اپلود' },
    { value: 4, key: 'RadioAndText', text: 'تک انخابی و تشریحی' },
    { value: 5, key: 'CheckAndText', text: 'چند انتخابی و تشریحی' },
    { value: 6, key: 'UploadAndText', text: 'تشریحی و اپلود فایل' },
  ],
  heroStatus: [
    { value: 0, key: 'Pending', text: 'در حال بررسی' },
    { value: 1, key: 'Accepted', text: 'تایید شده' },
    { value: 2, key: 'Rejected', text: 'رد شده' },
  ],
  heroGalleryStatus: [
    { value: 0, key: 'New', text: 'جدید', badge: 'info' },
    { value: 1, key: 'Pending', text: 'در حال بررسی', badge: 'warning' },
    { value: 2, key: 'Accepted', text: 'تایید شده', badge: 'success' },
    { value: 3, key: 'Rejected', text: 'رد شده', badge: 'danger' },
    { value: 4, key: 'Publish', text: 'منتشر شده', badge: 'primary' },
  ],
  heroGalleryType: [
    { value: 0, key: 'ImageGalleryBefore', type: 'image', text: 'تصویر قبل از رژیم' },
    { value: 1, key: 'ImageGalleryAfter', type: 'image', text: 'تصویر بعد از رژیم' },
    { value: 2, key: 'Video', type: 'video', text: 'ویدئو از قبل و بعد' },
    { value: 3, key: 'TeaserVideo', type: 'video', text: 'تیزر ساخته شده توسط مدیا کار', },
    { value: 4, key: 'SoundInterview ', type: 'audio', text: 'مصاحبه صوتی' },
    { value: 5, key: 'Cover ', type: 'audio', text: 'عکس کاور' },
  ],
  productStatus: [
    { value: 0, key: 'DeActive', text: 'غیرفعال', badge: 'warning' },
    { value: 1, key: 'Active', text: 'فعال', badge: 'success' },
    { value: 2, key: 'ComingSoon', text: 'به زودی', badge: 'primary' },
  ],
  blogBannersViewType: [
    { value: 0, text: 'popup' },
    { value: 1, text: 'down sticky banner' },
    { value: 2, text: 'slider' },
    { value: 3, text: 'mag left side banner' },
    { value: 4, text: 'top sticky banner' }
  ],
  placeType: [
    { value: 0, text: 'مجله' },
    { value: 1, text: 'لندینگ' }
  ],
  entities: [
    { value: 0, key: 'Food', text: 'غذاها' },
    { value: 1, key: 'Activity', text: 'فعالیت ها' },
    { value: 2, key: 'Blog', text: 'مقاله ها' },
    { value: 3, key: 'FoodComment', text: 'نظرات غذاها' },
    { value: 4, key: 'Faq', text: 'سوالات متداول' },
    { value: 5, key: 'BlogComment', text: 'نظرات مقاله ها' },
    { value: 6, key: 'ActivityPackage', text: 'برنامه های ورزشی' },
    { value: 7, key: 'FoodRecipes', text: 'دستور پخت ها' },
    { value: 8, key: 'FoodRecipesComment', text: 'نظرات دستور پخت ها' },
    { value: 9, key: 'ActivityComment', text: 'نظرات فعالیت ها' },
    { value: 10, key: 'ActivityPackageComment', text: 'نظرات برنامه های ورزشی' },
    { value: 11, key: 'HeroComment', text: 'نظرات رکوردداران' },
    { value: 12, key: 'Landing', text: 'لندینگ' },
    { value: 13, key: 'Banners', text: 'بنر ها' },
    { value: 14, key: 'GroupAvatar', text: 'گروه آواتار' },
    { value: 15, key: 'Messenger ', text: 'زیره گپ' },
    { value: 16, key: 'Plan', text: 'برنامه ها' },
    { value: 18, key: 'UserWage', text: 'فیش ها پرداختی' }
  ],
  fileType: [
    { value: 'all', key: 'all', text: 'همه' },
    { value: 1, key: 'image', text: 'عکس' },
    { value: 2, key: 'video', text: 'ویدئو' },
    { value: 3, key: 'sound', text: 'صدا' },
    { value: 4, key: 'doc', text: 'فایل' },
    { value: 0, key: 'none', text: 'بقیه موارد' },
  ],
  orderBy: [
    { value: 1, key: 'BySize', text: 'سایز' },
    { value: 2, key: 'ByCreate', text: 'تاریخ ایجاد' },
    { value: 4, key: 'ByType', text: 'نوع' },
  ],
  order: [
    { value: true, key: 'IsAscending', text: 'صعودی' },
    { value: false, key: 'IsAscending', text: 'نزولی' },
  ],
  heroContentType: [
    { value: 0, key: 'ByText', text: 'متن' },
    { value: 1, key: 'ByVideo', text: 'ویدئو' },
    { value: 2, key: 'BySound', text: 'صدا' },
    { value: 3, key: 'BySoundAndImage', text: 'صدا و عکس' },
  ],
  paymentPlace: [
    { value: false, key: 'web', text: 'اپ' },
    { value: true, key: 'app', text: 'وب' },
  ],
  msgGroupUserRole: [
    { value: 1, key: 'user', badge: 'secondary', text: 'کاربر' },
    { value: 0, key: 'admin', badge: 'primary', text: 'مدیر' },
  ],
  msgReportStatus: [
    { value: 1, key: 'UnBlocked', badge: 'secondary', text: 'تایید' },
    { value: 0, key: 'Blocked', badge: 'primary', text: 'عدم تایید' },
  ],
  MessageReportStatus: [
    { value: 0, title: 'نقض قوانین', badge: 'danger ' },
    { value: 1, title: 'بدون اشکال', badge: 'success' },
    { value: 2, title: 'گزارش مجدد', badge: 'secondary ' },
    { value: 3, title: 'در حال بررسی', badge: 'warning' },
  ],
  weightingRank: [
    { value: 0, key: 'A', text: 'A' },
    { value: 1, key: 'B', text: 'B' },
    { value: 2, key: 'C', text: 'C' },
    { value: 3, key: 'D', text: 'D' },
    { value: 4, key: 'E', text: 'E' },
  ],
  prizeType: [
    { value: 0, key: 'Coupon', text: 'کوپن تخفیف' },
    { value: 1, key: 'Diet', text: 'رژیم رایگان' },
    { value: 2, key: 'Activity', text: 'ورزش رایگان' },
    { value: 3, key: 'External', text: 'محصول خارج از سازمان' },
  ],
  callResultTypes: [
    { value: 0, key: 'CallCompleted', text: 'تماس انجام شد', badge: 'success' },
    { value: 1, key: 'Busy', text: 'خط اشغال بود', badge: 'info' },
    { value: 2, key: 'LineOff', text: 'موبایل خاموش بود', badge: 'warning' },
    { value: 3, key: 'OutOfNetwork', text: 'شماره در شبکه نبود', badge: 'warning' },
    { value: 4, key: 'CallDropped', text: 'رد تماس داد', badge: 'warning' },
    { value: 5, key: 'NoAnswer', text: 'جواب نداد', badge: 'warning' },
    { value: 6, key: 'WrongNumber', text: 'شماره اشتباه است', badge: 'info' },
    { value: 7, key: 'BlockedCall', text: 'انصراف از تماس', badge: 'primary' },
  ],
  RequestStatus: [
    { value: 0, key: 'WaitingCall', text: 'در انتظار تماس' },
    { value: 1, key: 'CallComplete', text: 'تماس برقرار شد' },
    { value: 2, key: 'CallCancell', text: 'انصراف از تماس' },
  ],
  RequestType: [
    { value: 0, key: 'Term14Call', text: 'تماس دوره 14 روزه' },
    { value: 1, key: 'FirstCall', text: 'تماس بعد از خرید' },
    { value: 2, key: 'Term28Call', text: 'تماس دوره 28 روزه' },
    { value: 3, key: 'SaleCall', text: 'تماس جهت فروش' },
  ],
  RelValues: [
    {
      "value": "",
      "title": "دنبال کردن",
      "description": "لینک معمولی - موتورهای جستجو این لینک را دنبال می‌کنند"
    },
    {
      "value": "nofollow",
      "title": "عدم دنبال کردن",
      "description": "به موتورهای جستجو می‌گوید این لینک را دنبال نکنند"
    },
    {
      "value": "noopener",
      "title": "بدون اوپنر",
      "description": "امنیتی برای target='_blank' - از دسترسی window.opener جلوگیری می‌کند"
    },
    {
      "value": "noreferrer",
      "title": "بدون رفرر",
      "description": "اطلاعات منبع ارجاع را در هدر HTTP پنهان می‌کند"
    },
    {
      "value": "alternate",
      "title": "جایگزین",
      "description": "نسخه جایگزین از سند فعلی (مثلاً PDF، زبان دیگر)"
    },
    {
      "value": "author",
      "title": "نویسنده",
      "description": "لینک به صفحه نویسنده یا اطلاعات تماس نویسنده"
    },
    {
      "value": "bookmark",
      "title": "بوکمارک",
      "description": "آدرس دائمی برای استفاده به عنوان بوکمارک"
    },
    {
      "value": "external",
      "title": "خارجی",
      "description": "لینک به وبسایت خارجی و غیر مرتبط"
    },
    {
      "value": "help",
      "title": "راهنما",
      "description": "لینک به document یا راهنمای مرتبط"
    },
    {
      "value": "license",
      "title": "لایسنس",
      "description": "لینک به اطلاعات کپی رایت و لایسنس"
    },
    {
      "value": "next",
      "title": "بعدی",
      "description": "لینک به صفحه بعدی در سری صفحات"
    },
    {
      "value": "prev",
      "title": "قبلی",
      "description": "لینک به صفحه قبلی در سری صفحات"
    },
    {
      "value": "search",
      "title": "جستجو",
      "description": "لینک به ابزار جستجوی مرتبط با صفحه"
    },
    {
      "value": "tag",
      "title": "تگ",
      "description": "لینک به تگ یا کلمه کلیدی مرتبط"
    },
    {
      "value": "canonical",
      "title": "کانونیکال",
      "description": "لینک به نسخه اصلی صفحه برای جلوگیری از محتوای تکراری"
    },
    {
      "value": "dns-prefetch",
      "title": "پیش واکشی DNS",
      "description": "به مرورگر می‌گوید DNS مربوط به دامنه مقصد را پیش واکشی کند"
    },
    {
      "value": "preconnect",
      "title": "اتصال پیش‌رس",
      "description": "اتصال اولیه به سرور مقصد برقرار می‌کند"
    },
    {
      "value": "prefetch",
      "title": "پیش واکشی",
      "description": "منبع مقصد را در کش مرورگر ذخیره می‌کند"
    },
    {
      "value": "preload",
      "title": "پیش بارگذاری",
      "description": "منبع را با اولویت بالا بارگذاری می‌کند"
    },
    {
      "value": "prerender",
      "title": "پیش رندر",
      "description": "صفحه مقصد را در پس‌زمینه رندر می‌کند"
    },
    {
      "value": "sponsored",
      "title": "اسپانسر شده",
      "description": "لینک‌های تبلیغاتی یا اسپانسر شده"
    },
    {
      "value": "ugc",
      "title": "محتوای تولید کاربر",
      "description": "لینک‌های موجود در محتوای تولید شده توسط کاربر"
    },
    {
      "value": "me",
      "title": "صفحه من",
      "description": "لینک به پروفایل یا صفحات اجتماعی مربوط به نویسنده"
    },
    {
      "value": "noopener noreferrer",
      "title": "ترکیب امنیتی",
      "description": "ترکیب رایج برای لینک‌های خارجی با target='_blank' برای امنیت بیشتر"
    },
    {
      "value": "nofollow noopener",
      "title": "ترکیب سئو و امنیت",
      "description": "هم عدم دنبال کردن توسط موتورهای جستجو و هم امنیت لینک"
    }
  ],

}
